import React, { useEffect, useState } from 'react'
import TreasuryDaily from './pages/TreasuryDaily.jsx'
import FxDeposit from './pages/FxDeposit.jsx'
import Work from './pages/Work.jsx'
import Vendors from './pages/Vendors.jsx'
import DataExport from './pages/DataExport.jsx'
import Reports from './pages/Reports.jsx'
import SourceData from './pages/SourceData.jsx'
import Securities from './pages/Securities.jsx'
import Home from './pages/Home.jsx'
import Approval from './pages/Approval.jsx'
import TreasuryMatch from './pages/TreasuryMatch.jsx'
import Admin from './pages/Admin.jsx'
import Sales from './pages/Sales.jsx'
import NoteStats from './pages/NoteStats.jsx'
import Edoc from './pages/Edoc.jsx'
import Planned from './pages/Planned.jsx'
import FundPlanScreen from './pages/FundPlan.jsx'
import SalesRevenueScreen from './pages/SalesRevenue.jsx'
import ExecReport from './pages/ExecReport.jsx'
import Pnl from './pages/Pnl.jsx'
import Manual from './pages/Manual.jsx'
// 원가관리 — /api/cost 백엔드를 쓰는 화면들. 옛 화면(/api/items·/api/ledger, Express)에서
// 갈아끼웠고 데이터는 wonga DB 에서 erp 의 cost_* 로 옮겼다.
import CostDashboard from './pages/CostDashboard.jsx'
import CostImport from './pages/CostImport.jsx'
import CostBasis from './pages/CostBasis.jsx'
import CostProduction from './pages/CostProduction.jsx'
import CostPurchase from './pages/CostPurchase.jsx'
import CostJournal from './pages/CostJournal.jsx'
import CostInventory from './pages/CostInventory.jsx'
import CostTransactions from './pages/CostTransactions.jsx'
import CostAllowance from './pages/CostAllowance.jsx'
import CostItems from './pages/CostItems.jsx'
import CostTabs from './pages/CostTabs.jsx'

// 원가관리는 화면이 열 개라 사이드바가 그것만으로 꽉 찬다. 성격이 같은 것끼리 탭으로 묶어
// 메뉴는 넷으로 줄이고 화면 자체는 그대로 둔다. screenKey 는 탭마다 살아 있어 권한도 그대로다.
const COST_TABS = {
  calc: [
    { key: 'basis', label: '배부기준(원장)', comp: CostBasis, screenKey: 'cost_basis' },
    { key: 'production', label: '생산·제조원가 명세', comp: CostProduction, screenKey: 'cost_production' },
    { key: 'journal', label: '분개', comp: CostJournal, screenKey: 'cost_journal' },
  ],
  stock: [
    { key: 'inventory', label: '재고수불부', comp: CostInventory, screenKey: 'cost_inventory' },
    { key: 'transactions', label: '입출고', comp: CostTransactions, screenKey: 'cost_transactions' },
    { key: 'purchase', label: '매입', comp: CostPurchase, screenKey: 'cost_purchase' },
    { key: 'allowance', label: '충당금', comp: CostAllowance, screenKey: 'cost_allowance' },
  ],
  base: [
    { key: 'items', label: '품목', comp: CostItems, screenKey: 'cost_items' },
    { key: 'import', label: '엑셀 가져오기', comp: CostImport, screenKey: 'cost_import' },
  ],
}
const CostCalc = (p) => <CostTabs tabs={COST_TABS.calc} storeKey="cost-tab-calc" {...p} />
const CostStock = (p) => <CostTabs tabs={COST_TABS.stock} storeKey="cost-tab-stock" {...p} />
const CostBase = (p) => <CostTabs tabs={COST_TABS.base} storeKey="cost-tab-base" {...p} />
import { Icon } from './Icons.jsx'

const Bank = (p) => <SourceData kind="bank" {...p} />
const Tax = (p) => <SourceData kind="tax" {...p} />
const Card = (p) => <SourceData kind="card" {...p} />
const EdocInbox = (p) => <Edoc sub="inbox" {...p} />
const EdocDraft = (p) => <Edoc sub="draft" {...p} />
const EdocMine = (p) => <Edoc sub="mine" {...p} />
const EdocApprover = (p) => <Edoc sub="approver" {...p} />
const EdocTransfers = (p) => <Edoc sub="transfers" {...p} />
const EdocAll = (p) => <Edoc sub="all" {...p} />
// 구축 예정 화면 — 메뉴·권한을 먼저 잡아둔다 (설계는 Planned.jsx의 PLANNED)
const ClosingAssets = (p) => <Planned spec="closing_assets" {...p} />
const ClosingDepreciation = (p) => <Planned spec="closing_depreciation" {...p} />
const ClosingPrepaid = (p) => <Planned spec="closing_prepaid" {...p} />
const ClosingLease = (p) => <Planned spec="closing_lease" {...p} />
const ClosingClose = (p) => <Planned spec="closing_close" {...p} />
const FundPlan = (p) => <FundPlanScreen defaultMode="plan" {...p} />
const SalesRevenue = (p) => <SalesRevenueScreen {...p} />
import Login, { 표식치우기 } from './pages/Login.jsx'
import ChangePassword from './pages/ChangePassword.jsx'
import NotificationBell from './components/NotificationBell.jsx'
import CompanySwitcher from './components/CompanySwitcher.jsx'
import { portal } from './portalApi.js'

// 재무경영팀 ERP — React 단일 앱으로 전체 기능 통합 중.
// comp 있는 항목 = 이식 완료(네이티브), todo = 순차 이식 예정(그동안 기존 포털에서 사용)
const GROUPS = [
  {
    title: '홈',
    plain: true, // 대분류 헤더/토글 없이 항목만 표시
    items: [
      { key: 'home', label: '홈', icon: Icon.home, comp: Home },
      // 경영진이 매달 받아 가는 한 장. 홈은 우리가 오늘 처리할 일이고, 이건 결과다.
      { key: 'exec-report', label: '경영보고', icon: Icon.report, comp: ExecReport, screenKey: 'exec_report' },
      // 경영보고 바로 밑이다 - 경영진에게 올라가는 글끼리 모아 둔다. 데이터 묶음에
      // 있을 때는 수집·전표 화면들 사이에 끼어 있어, 보고를 찾는 사람이 거기를 안 봤다.
      { key: 'd-reports', label: '보고서', icon: Icon.files, comp: Reports, screenKey: 'reports' },
    ],
  },
  {
    title: '데이터',
    items: [
      // 기초설정이 맨 위다. 계좌·카드·거래처의 이름과 분류가 여기서 정해지고
      // 나머지 화면은 그것을 따라 보이므로, 무엇이 이상하면 여기부터 열게 된다.
      { key: 'd-vendors', label: '기초설정', icon: Icon.master, comp: Vendors, screenKey: 'data_vendors' },
      { key: 'd-bank', label: '계좌', icon: Icon.bank, comp: Bank, screenKey: 'data_bank' },
      { key: 'd-tax', label: '세금계산서', icon: Icon.tax, comp: Tax, screenKey: 'data_tax' },
      { key: 'd-card', label: '신용카드', icon: Icon.card, comp: Card, screenKey: 'data_card' },
      { key: 'd-securities', label: '증권', icon: Icon.securities, comp: Securities, screenKey: 'data_securities' },
      // 전표승인은 계좌·카드·세금계산서를 훑고 나서 하는 일이라 그 다음에 둔다
      { key: 'approval', label: '전표승인', icon: Icon.approve, comp: Approval, screenKey: 'approval' },
      // 다른 팀 앱에 우리 데이터를 열어 주는 열쇠를 다루는 곳. 데이터를 보는 것과
      // 남에게 열어 주는 것은 다른 일이라 권한이 따로다(관리자만).
      { key: 'd-export', label: '내보내기 관리', icon: Icon.share, comp: DataExport, screenKey: 'data_export' },
    ],
  },
  {
    title: '자금',
    items: [
      { key: 'treasury-daily', label: '자금일보', icon: Icon.coins, comp: TreasuryDaily, screenKey: 'treasury_daily_report' },
      { key: 'treasury-fx', label: '외화예금', icon: Icon.fx, comp: FxDeposit, screenKey: 'treasury_fx' },
      // 계획 대비 실적은 따로 두지 않는다 - 자금계획 안에서 계획/실적/차이를 바꿔 본다
      { key: 'fund-plan', label: '자금계획', icon: Icon.plan, comp: FundPlan, screenKey: 'fund_plan' },
    ],
  },
  {
    title: '매출',
    items: [
      { key: 'sales-revenue', label: '매출', icon: Icon.cart, comp: SalesRevenue, screenKey: 'sales' },
    ],
  },
  {
    title: '원가관리',
    items: [
      { key: 'dashboard', label: '대시보드', icon: Icon.chart, comp: CostDashboard, screenKey: 'cost_dashboard' },
      { key: 'cost-calc', label: '원가계산', icon: Icon.factory, comp: CostCalc,
        screenKeys: COST_TABS.calc.map((t) => t.screenKey) },
      { key: 'cost-stock', label: '재고', icon: Icon.box, comp: CostStock,
        screenKeys: COST_TABS.stock.map((t) => t.screenKey) },
      { key: 'cost-base', label: '기준정보', icon: Icon.tag, comp: CostBase,
        screenKeys: COST_TABS.base.map((t) => t.screenKey) },
    ],
  },
  {
    title: '결산',
    items: [
      // 손익계산서는 위하고에서 받아 그대로 보여주는 화면이라 구축예정이 아니다
      { key: 'closing-pnl', label: '손익계산서', icon: Icon.pnl, comp: Pnl, screenKey: 'closing_pnl' },
      { key: 'closing-assets', label: '자산대장', icon: Icon.asset, comp: ClosingAssets, screenKey: 'closing_assets' },
      { key: 'closing-dep', label: '감가상각', icon: Icon.depreciation, comp: ClosingDepreciation, screenKey: 'closing_depreciation' },
      { key: 'closing-prepaid', label: '선급비용', icon: Icon.prepaid, comp: ClosingPrepaid, screenKey: 'closing_prepaid' },
      { key: 'closing-lease', label: '리스', icon: Icon.doc, comp: ClosingLease, screenKey: 'closing_lease' },
      { key: 'closing-close', label: '결산 마감', icon: Icon.lock, comp: ClosingClose, screenKey: 'closing_close' },
    ],
  },
  {
    title: '전자결재',
    items: [
      { key: 'edoc-inbox', label: '결재함', icon: Icon.inbox, comp: EdocInbox, screenKey: 'edoc_inbox' },
      { key: 'edoc-draft', label: '기안하기', icon: Icon.pen, comp: EdocDraft, screenKey: 'edoc_draft' },
      { key: 'edoc-mine', label: '내 문서', icon: Icon.folder, comp: EdocMine, screenKey: 'edoc_mine' },
      { key: 'edoc-approver', label: '내가 결재자', icon: Icon.sign, comp: EdocApprover, screenKey: 'edoc_approver' },
      { key: 'edoc-transfers', label: '자금이체 관리', icon: Icon.transfer, comp: EdocTransfers, screenKey: 'edoc_transfers' },
      // 결재는 났는데 안 나간 건 / 나갔는데 결재가 없는 건을 걸러낸다. 이체를 실행하고 나서
      // 확인하는 화면이라 계좌(전표처리)가 아니라 자금이체 옆이 맞다.
      { key: 'treasury-match', label: '매칭현황', icon: Icon.link, comp: TreasuryMatch, screenKey: 'treasury' },
      { key: 'edoc-all', label: '전체문서', icon: Icon.archive, comp: EdocAll, adminOnly: true },
    ],
  },
  {
    title: '업무관리',
    items: [
      { key: 'work', label: '업무관리', icon: Icon.check, comp: Work, screenKey: 'work' },
    ],
  },
  {
    title: '관리',
    items: [
      { key: 'admin', label: '관리자', icon: Icon.gear, comp: Admin, adminOnly: true },
      { key: 'note-stats', label: '서랍(메모) 현황', icon: Icon.note, comp: NoteStats, adminOnly: true },
    ],
  },
  {
    title: '판매·재고',
    items: [
      { key: 'sales', label: '판매·재고', icon: Icon.store, comp: Sales, screenKey: 'sales_inventory' },
    ],
  },
  {
    // 맨 아래에 둔다 - 매일 쓰는 화면이 아니라 막혔을 때 찾는 화면이다.
    title: '도움말',
    items: [
      { key: 'manual', label: '업무매뉴얼', icon: Icon.manual, comp: Manual, screenKey: 'manual' },
    ],
  },
]

// 서랍(메모) 알림에서 "어디서"를 사람이 읽을 말로 보여주기 위한 target->label
// 탭으로 묶은 화면도 알림에 이름이 떠야 한다 - 메뉴 항목만 모으면 "원가계산"까지만 남는다
const TARGET_LABELS = Object.fromEntries([
  ...GROUPS.flatMap((g) => g.items).map((t) => [t.key, t.label]),
  ...Object.values(COST_TABS).flat().map((t) => [t.key, t.label]),
])

// 기본 기준월: 현재 연월
const now = new Date()
const defaultMonth = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`

// 재무포털 iframe 안에 내장되어 뜰 때는 원가관리 그룹만 노출 (전환기 호환)
const inFrame = window.self !== window.top

// 알림 딥링크(?tab=&month=&note=) - 최초 1회만 읽고 URL은 지운다
const _deepLink = (() => {
  try {
    const p = new URLSearchParams(window.location.search)
    if (!p.get('note')) return null
    return { tab: p.get('tab') || null, month: p.get('month') || null, note: Number(p.get('note')) || null }
  } catch { return null }
})()

// WORK 알림 딥링크(?doc=123) — 전자결재 문서 하나를 바로 연다 (공통계약 C절)
const _docLink = (() => {
  try {
    const id = Number(new URLSearchParams(window.location.search).get('doc'))
    return Number.isInteger(id) && id > 0 ? id : null
  } catch { return null }
})()

export default function App() {
  const [tab, setTab] = useState(inFrame ? 'dashboard' : (_deepLink?.tab || 'home'))
  const [month, setMonth] = useState(_deepLink?.month || defaultMonth)
  const [pendingNoteId, setPendingNoteId] = useState(_deepLink?.note || null)
  // 다른 화면으로 건너갈 때 «어느 탭을 펴고 들어갈지»를 같이 넘긴다. 이게 없으면
  // 자금일보에서 계좌 설정을 눌러도 기초설정의 첫 탭(거래처)이 열린다.
  const [pendingSub, setPendingSub] = useState(null)
  const [pendingWorkId, setPendingWorkId] = useState(null)
  const [pendingJournal, setPendingJournal] = useState(null)
  const [docLink, setDocLink] = useState(_docLink)
  const [user, setUser] = useState(undefined) // undefined=확인중, null=미로그인
  const [collapsed, setCollapsed] = useState(() => {
    // 저장된 상태(사용자가 여닫은 기록)가 있으면 그대로, 없으면 기본 전부 닫힘
    try {
      const saved = localStorage.getItem('nav-collapsed')
      if (saved) return JSON.parse(saved)
    } catch {}
    return Object.fromEntries(GROUPS.map((g) => [g.title, true]))
  })
  const year = Number(month.slice(0, 4))

  const toggleGroup = (title) => {
    setCollapsed((p) => {
      const n = { ...p, [title]: !p[title] }
      try { localStorage.setItem('nav-collapsed', JSON.stringify(n)) } catch {}
      return n
    })
  }

  useEffect(() => {
    if (import.meta.env.DEV) {
      // 로컬 개발: 포털 세션 없이 개발 (운영에서는 포털 계정 로그인)
      setUser({ name: '개발 모드', dev: true })
      return
    }
    portal.get('/api/auth/me')
      .then((me) => {
        // 들어왔으면 포털이 붙여 보낸 표식을 주소에서 치운다. 로그인 화면은 그 표식을
        // 보고 「쿠키가 저장되지 않았다」고 알리므로, 성공한 쪽에서는 남겨 둘 이유가 없다.
        if (me.loggedIn) 표식치우기()
        setUser(me.loggedIn ? me : null)
      })
      .catch(() => setUser(null))
  }, [])

  useEffect(() => {
    if (_deepLink) {
      try { window.history.replaceState({}, '', window.location.pathname) } catch {}
    }
  }, [])

  const goToNotification = (n) => {
    // 업무 알림은 목적지가 정해져 있다 — 업무관리 화면의 그 업무 한 건.
    if (n.kind === 'work') {
      setTab('work')
      // 일지 댓글은 열 업무가 없다. 그날 그 사람의 업무일지로 보낸다.
      if (n.journal_id) setPendingJournal({ day: n.일지일자, who: n.일지작성자_id })
      else setPendingWorkId(n.work_id)
      return
    }
    setTab(n.target)
    if (n.context?.month) setMonth(n.context.month)
    setPendingNoteId(n.note_id)
  }

  const canSee = (t) => {
    if (user?.isAdmin || user?.dev) return true
    if (t.adminOnly) return false
    if (t.key === 'home') return true // 홈은 공용 랜딩 화면 - 권한 무관 항상 노출
    // 탭으로 묶은 메뉴는 그중 하나라도 권한이 있으면 보인다(탭 자체는 CostTabs가 또 거른다)
    if (t.screenKeys) return t.screenKeys.some((k) => (user?.screens || []).includes(k))
    // screenKey가 없는(=권한 연결을 깜빡한) 화면은 기본적으로 숨김 - 새로 추가한 화면이
    // 실수로 전체 공개되는 사고를 막기 위한 안전장치(fail-closed).
    return (user?.screens || []).includes(t.screenKey)
  }
  const groups = (inFrame ? GROUPS.filter((g) => g.title === '원가관리') : GROUPS)
    .map((g) => ({ ...g, items: g.items.filter(canSee) }))
    .filter((g) => g.items.length > 0)
  const active = groups.flatMap((g) => g.items).find((t) => t.key === tab) ?? groups[0].items[0]
  // 상단바 빵부스러기에 쓸 그룹 이름. 홈·경영보고처럼 묶음이 없는 것은 비워 둔다.
  const 활성그룹 = groups.find((g) => !g.plain && g.items.some((t) => t.key === active?.key))?.title || ''

  const logout = async () => {
    try { await portal.post('/api/auth/logout') } catch {}
    setUser(null)
  }

  if (user === undefined) return <div className="login-wrap"><div className="muted">로그인 확인 중…</div></div>
  if (user === null) return <Login onLogin={setUser} />
  if (user.mustChangePassword) return <ChangePassword user={user} onChanged={setUser} />
  // 로그인은 됐는데 열린 화면이 하나도 없는 사람. 포털 SSO 로 처음 들어온 사람이 여기다.
  // 빈 화면만 뜨면 고장난 줄 알고 다시 로그인하려 든다 - 무엇을 기다리는지 말해 준다.
  if (!user.dev && !user.isAdmin && !(user.screens || []).length) {
    return (
      <div className="login-wrap">
        <div className="login-card" style={{ gap: 10 }}>
          <div className="login-title">재무경영팀 ERP</div>
          <div className="login-sub">
            <b>{user.name}</b>님, 로그인됐습니다.
            {(user.team || user.division) && (
              <div className="muted" style={{ fontSize: 12, marginTop: 2 }}>
                {[user.division, user.team, user.rank].filter(Boolean).join(' · ')}
              </div>
            )}
          </div>
          <div className="hint" style={{ textAlign: 'left', lineHeight: 1.7 }}>
            아직 열린 화면이 없습니다. <b>관리자 승인을 기다리는 중</b>입니다.
            <br />
            재무경영팀에 연락해 필요한 화면을 요청해 주세요 — 관리자가
            [기초설정 &gt; 부서·인원]에서 권한을 열어 주면 바로 보입니다.
          </div>
          <button className="btn secondary" onClick={logout}>로그아웃</button>
          <div className="login-foot muted">주식회사 에르모어 · fa.ermore.ai</div>
        </div>
      </div>
    )
  }

  return (
    <div className="layout">
      <aside className="sidebar">
        {!inFrame && (
          <>
            <h1>재무경영팀 ERP</h1>
            {/* 화면이 회사마다 똑같이 생겼고 숫자만 다르다. 어느 회사인지 늘 보여야 한다. */}
            <CompanySwitcher />
          </>
        )}
        <div className="month-pick">
          <span className="muted">기준월</span>
          <input type="month" value={month} onChange={(e) => e.target.value && setMonth(e.target.value)} />
        </div>
        <nav>
          {groups.map((g) => (
            <div className={`nav-group ${g.plain ? 'plain' : ''}`} key={g.title}>
              {!g.plain && (
                <button className="nav-group-title" onClick={() => toggleGroup(g.title)}>
                  {g.title}
                  <span className={`chev ${collapsed[g.title] ? '' : 'open'}`}>›</span>
                </button>
              )}
              {(g.plain || !collapsed[g.title]) && g.items.map((t) => (
                <button
                  key={t.key}
                  className={`${tab === t.key ? 'active' : ''} ${t.todo ? 'todo' : ''}`}
                  disabled={t.todo}
                  title={t.todo ? '이식 진행 중 — 완료 전까지 기존 포털에서 사용' : undefined}
                  onClick={() => !t.todo && setTab(t.key)}
                >
                  <span className="icon">{t.icon ? <t.icon /> : null}</span>
                  {t.label}
                  {t.todo && <span className="badge-todo">이식중</span>}
                </button>
              ))}
            </div>
          ))}
        </nav>
      </aside>
      <div className="shell">
        {/* 상단바 — ERMORE OS 와 같은 자리, 같은 높이(64)다. 지금 어느 화면인지(빵부스러기)와
            알림·사람·로그아웃이 여기 모인다. 예전에는 사이드바 맨 아래에 있어서, 메뉴가
            길어지면 스크롤을 내려야 제 이름이 보였다. */}
        {!inFrame && (
          <header className="topbar">
            <div className="tb-left">
              <span className="tb-crumb">
                {활성그룹 && <><span className="muted">{활성그룹}</span><i className="sep">›</i></>}
                <b>{active?.label || ''}</b>
              </span>
            </div>
            <div className="tb-right">
              <NotificationBell targetLabels={TARGET_LABELS} onNavigate={goToNotification} />
              <span className="tb-user">
                <i className="tb-ava">{(user.name || '?').trim().slice(0, 1)}</i>
                <b>{user.name}</b>
                {user.isAdmin && <span className="muted">관리자</span>}
              </span>
              {!user.dev && <button className="tb-btn" onClick={logout}>로그아웃</button>}
            </div>
          </header>
        )}
      <main className="content">
        {docLink ? (
          /* WORK 알림에서 넘어온 문서 하나만 연다 (?doc=123). 닫으면 평소 화면으로 돌아간다 */
          <>
            <div className="row" style={{ marginBottom: 10 }}>
              <button className="btn secondary" onClick={() => setDocLink(null)}>← 목록으로</button>
            </div>
            <Edoc sub="doc" docId={docLink} currentUserId={user.id} />
          </>
        ) : (
          <active.comp month={month} year={year} onMonthChange={setMonth}
            goto={(key, sub) => { setPendingSub(sub || null); setTab(key) }}
            subTab={active.key === tab ? pendingSub : null}
            onSubOpened={() => setPendingSub(null)}
            currentUserId={user.id} targetLabels={TARGET_LABELS} isAdmin={!!user.isAdmin}
            screens={user.screens || []}
            autoOpenNoteId={active.key === tab ? pendingNoteId : null}
            onAutoOpened={() => setPendingNoteId(null)}
            autoOpenWorkId={active.key === tab ? pendingWorkId : null}
            onWorkOpened={() => setPendingWorkId(null)}
            autoOpenJournal={active.key === tab ? pendingJournal : null}
            onJournalOpened={() => setPendingJournal(null)} />
        )}
      </main>
      </div>
    </div>
  )
}
